export default __webpack_public_path__ + "static/media/report.5905c191.svg";